(ns app.front.view.group.admin.mfa.core
  (:require [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.radio :as ui-radio]
            [app.front.ui.section :as section]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.group.admin.subs :as gas]
            [clojure.string :as str]
            [core.authorization.mfa.model :as mfa-model]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema-tools.core :as st]
            [schema.core :as s]))


(def default-config {::new-config?                   true
                     :mfa-config/type                :mfa-config.type/duo-oidc
                     :mfa-config/id                  "new-config"
                     :mfa-config/display-name        "New configuration"
                     :mfa-config/users-can-disable?  false
                     :mfa-config/enabled-by-default? true})


(rf/reg-event-fx ::fetch-mfa-configs
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/mfa-configs
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::entities/merge-entity-db]}}))


(rf/reg-event-fx ::save-config
  (fn [{:keys [db]} [_ config group-id]]
    {:db           (assoc-in db [::data ::saving?] true)
     :comm/command {:command          :group/save-mfa-config
                    :method           :post
                    :data             {:group-id group-id
                                       :config   (->> (dissoc config ::new-config?)
                                                      (p/filter-vals #(or (not (string? %))
                                                                          (not (str/blank? %)))))}
                    :on-success       [::save-config.success]
                    :finally-dispatch [::stop-saving]}}))


(rf/reg-event-fx ::save-config.success
  (fn [{:keys [db]} [_ status response]]
    {:db         (assoc-in db [::data ::saving?] false)
     :dispatch-n [[::entities/apply-changes status response]
                  [::set-config-in-editor nil]
                  [:notifications/add :toast :success :success :group-admin.mfa-config/saved]]}))


(rf/reg-event-fx ::delete-config
  (fn [_ [_ mfa-config]]
    {:comm/command {:command          :group/delete-mfa-config
                    :method           :post
                    :data             (select-keys mfa-config [:mfa-config/id])
                    :on-success       [::delete-config.success (:db/id mfa-config)]
                    :finally-dispatch [::stop-saving]}}))


(rf/reg-event-fx ::delete-config.success
  (fn [_ [_ id]]
    {:dispatch-n [[::entities/remove-entity id]
                  [::set-config-in-editor nil]
                  [:notifications/add :toast :success :success :group-admin.mfa-config/deleted]]}))


(rf/reg-event-db ::stop-saving
  #(assoc-in % [::data ::saving?] false))



(rf/reg-event-db ::set-config-in-editor
  (fn [db [_ config]]
    (assoc-in db
              [::data ::config-in-editor]
              ; De-entityize
              (select-keys config (concat (keys (st/required-keys mfa-model/MFAConfigKeys))
                                          (keys default-config)
                                          [:db/id])))))


(rf/reg-event-db ::set-editor-value
  (fn [db [_ k v]]
    (if (or (nil? v) (and (string? v) (str/blank? v)))
      (p/dissoc-in db [::data ::config-in-editor k])
      (assoc-in db [::data ::config-in-editor k] v))))


(rf/reg-sub ::config-in-editor
  #(-> % ::data ::config-in-editor))


(rf/reg-sub ::save-in-progress?
  #(-> % ::data ::saving?))


(rf/reg-sub ::mfa-configs
  :<- [::gas/group-id]
  :<- [::entities/context]
  (fn [[group-id ctx]]
    (entities/find-entities ctx {:entity/type      :entity.type/mfa-config
                                 :mfa-config/group group-id})))


(defn labeled-text [label text]
  [:div
   [:div.bx--label label]
   [:div.label-value text]])


(defn field [tr editing? k config config-in-editor]
  [:div.mt-3
   (if editing?
     [ui/text-input {:id          (name k)
                     :label-text  (tr [k])
                     :value       (get config-in-editor k)
                     :on-change   #(>evt [::set-editor-value k (futil/tval %)])
                     :helper-text (when (mfa-model/secret-fields k)
                                    (tr [:gis-server-config/password-hidden]))}]
     [labeled-text (tr [k]) (or (get config k)
                                (tr [(if (mfa-model/secret-fields k)
                                       :gis-server-config/password-hidden
                                       :common/not-set)]))])])


(def schema-errors (s/checker mfa-model/MFAAnyConfig))


(defn mfa-config [{:keys [tr config]}]
  (let [config-in-editor (<sub [::config-in-editor])
        group-id         (<sub [::gas/group-id])
        id               (:mfa-config/id config-in-editor)
        editing?         (or (-> config :db/id (= (:db/id config-in-editor)))
                             (-> config :db/id nil?))
        config-type      (if editing?
                           (:mfa-config/type config-in-editor)
                           (:mfa-config/type config))
        invalid?         (boolean (schema-errors (dissoc config-in-editor ::new-config?)))]
    [section/section
     id
     {:tr             tr
      :heading-button (cc/button
                        {:on-click         #(>evt [::set-config-in-editor (when-not editing?
                                                                            config)])
                         :icon             (if editing?
                                             i/remove
                                             i/pen)
                         :icon-position    :right
                         :icon-description (tr [(if editing?
                                                  :cancel
                                                  :edit)])
                         :class-name       "only-icon-button"
                         :kind             :ghost}
                        "")}
     (:mfa-config/display-name config)
     [:div.flex.flex-row.flex-1.flex-wrap.items-end.justify-between
      [:div.flex.flex-col.w-full.lg:w-2-3.lg:w-auto.max-w-xl.mb-3
       [ui-radio/radio
        {:name       (str id "-mfa-type")
         :label-text (tr [:mfa-config/type])
         :values     mfa-model/config-types
         :value      config-type
         :on-change  #(>evt [::set-editor-value :mfa-config/type %])
         :val->str   (comp tr vector)
         :disabled   true}]
       (for-frag [k (get mfa-model/config-type->key-order config-type)]
         [field tr editing? k config config-in-editor])
       (for-frag [k mfa-model/checkbox-fields]
         [:div.mt-2
          (cc/checkbox {:id         (str id "-" (name k))
                        :checked    (-> (if editing? config-in-editor config)
                                        (get k)
                                        boolean)
                        :label-text (tr [k])
                        :disabled   (not editing?)
                        :on-change  #(>evt [::set-editor-value k %])})])]
      (when editing?
        (if (<sub [::save-in-progress?])
          [:div.flex
           (cc/inline-loading {:description (tr [:saving])})]
          [:div.flex
           (when (:db/id config)
             [ui/modal-confirmation-button
              {:tr                  tr
               :id                  "delete-config"
               :on-yes-click        #(>evt [::delete-config config])
               :modal-title         (tr [:group-admin.mfa-config/delete-title])
               :trigger-button-opts {:kind       :danger
                                     :class-name "mr-6"}
               :trigger-button-text (tr [:delete])}
              (tr [:group-admin.mfa-config/delete-confirmation]
                  [(:mfa-config/display-name config)])])
           (cc/button
             {:on-click   #(>evt [::set-config-in-editor nil])
              :kind       :tertiary
              :class-name "mr-1"}
             (tr [:cancel]))
           (cc/button
             {:on-click #(>evt [::save-config config-in-editor group-id])
              :kind     :primary
              :disabled invalid?}
             (tr [:save]))]))]]))


(defn view [_]
  (let [tr        (<sub [:tr])
        show-new? (-> (<sub [::config-in-editor]) ::new-config?)
        configs   (<sub [::mfa-configs])]
    [:div.cloudpermit-page.admin-page
     [:div.bx--row.page-heading.justify-between
      [:h1 (tr [:view/group.admin.mfa])]
      ;; Limit to just one config per group for now
      (when (and (empty? configs)
                 (not show-new?))
        (cc/button
          {:icon-position    :left
           :icon             i/plus
           :icon-description ""
           :on-click         #(>evt [::set-config-in-editor default-config])}
          (tr [:group-admin.mfa-config/add-new])))]
     (when show-new?
       [mfa-config {:tr     tr
                    :config default-config}])
     (for-frag [config configs]
       [mfa-config {:tr     tr
                    :config config}])]))


(def route
  {:name        :view/group.admin.mfa
   :view        view
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [{{:keys [group-id]} :path}]
                                (>evt [::fetch-mfa-configs group-id]))}]})
